module.exports = __webpack_public_path__ + "static/Theo_Rougier-323f48d0851a648c59ed92104efb2dce.png";